import { useEffect, useRef, useState } from "react";
import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import styles from "./Breadcrumbs.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);
type Props = {
  /**
   * A string representing the breadcrumb path.
   */
  breadcrumbPath: string;
  /**
   * A boolean on whether this is beauty simplification
   */
  beautySimplification: boolean;
  /**
   * boolean if the config prop and breadcrumb position match
   */
  isBreadcrumbsMatchPositionTwo?: boolean;
};

export const BreadcrumbsUI = ({
  breadcrumbPath,
  beautySimplification,
  isBreadcrumbsMatchPositionTwo = false,
}: Props) => {
  return (
    <div
      data-testid="breadcrumbs"
      className={cx("esi-wrapper", {
        beautySimplification,
        breadcrumbsPositionTwo: isBreadcrumbsMatchPositionTwo,
      })}
      data-component="Breadcrumbs"
    >
      <ESIInclude src={breadcrumbPath} id={"breadcrumbs"} />
    </div>
  );
};
